// /* eslint-disable react-hooks/exhaustive-deps */
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { Link, useNavigate } from "react-router-dom";

// const Profile = () => {
//   const navigate = useNavigate();
//   const [userProfile, setUserProfile] = useState({
//     firstName: "",
//     lastName: "",
//     phoneNumber: "",
//     avtar: "",
//   });
//   const authData = localStorage.getItem("auth");

//   const authObject = JSON.parse(authData);
//   console.log("authObject", authObject);

//   const token = authObject?.accessToken;
//   console.log("token", token);
//   useEffect(() => {
//     // Retrieve user profile data from API
//     const fetchUserProfile = async () => {
//       try {
//         const res = await axios.get(
//           `${API_BASE}/user/getCurrentUser`,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );
//         console.log("res", res);
//         setUserProfile(res.data.data);
//       } catch (error) {
//         console.error("Error fetching user profile:", error);
//       }
//     };
//     fetchUserProfile();
//   }, []);

//   // const handleImageChange = async (e) => {
//   //   const file = e.target.files[0];
//   //   if (file) {
//   //     const formData = new FormData();
//   //     formData.append("avatar", file);

//   //     // Debug: Log FormData entries
//   //     for (let pair of formData.entries()) {
//   //       console.log(pair[0] + ": " + pair[1]);
//   //     }

//   //     try {
//   //       const { data } = await axios.post(
//   //         "http://localhost:4000/user/updateAvatar",
//   //         formData,
//   //         {
//   //           headers: {
//   //             Authorization: `Bearer ${token}`,
//   //           },
//   //         }
//   //       );
//   //       console.log("data", data);

//   //       // Update the profile image after successful upload
//   //       setUserProfile((prevProfile) => ({
//   //         ...prevProfile,
//   //         avtar: data.data.avtar,
//   //       }));
//   //     } catch (error) {
//   //       console.error("Error updating profile image:", error);
//   //     }
//   //   } else {
//   //     console.error("No file selected.");
//   //   }
//   // };
//   const handlehistory = () => {
//     navigate("/OrderHistory");
//   };


//   const handleLogout = () => {
//     localStorage.clear();
//     navigate("/");
//   };
// const API_BASE = process.env.REACT_APP_API_BASE;

//   return (
//     <div
//       className="flex items-center justify-center min-h-screen bg-cover bg-center px-4"
//       style={{
//         backgroundImage:
//           "url('https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1950&q=80')",
//       }}
//     >
//       <div className="max-w-sm w-full bg-white bg-opacity-95 rounded-lg overflow-hidden shadow-md p-5 border border-gray-300">
//         <h2 className="text-center text-2xl mb-6 text-gray-800">
//           {userProfile.role === "provider" ? "Employee Profile" : "Profile"}
//         </h2>
//         <div className="border-b px-4 pb-6">
//           <div className="text-center my-4">
//             <div className="py-2">
//               {/* You can include profile picture here */}
//             </div>
//           </div>

//           <div className="py-2">
//             <div className="text-left text-gray-800">
//               <div className="mb-2">
//                 <h1 className="block text-gray-500 font-semibold">
//                   First Name: {userProfile.firstName}
//                 </h1>
//                 <h1 className="block text-gray-500 font-semibold">
//                   Last Name: {userProfile.lastName}
//                 </h1>
//                 <h1 className="block text-gray-500 font-semibold">
//                   Phone Number: {userProfile.phoneNumber}
//                 </h1>
//               </div>
//             </div>
//           </div>

//           <div className="flex flex-col gap-2 px-2">
//             <Link to="/update-profile" className="w-full">
//               <button className="bg-red-500 w-full text-white py-2 px-4 rounded cursor-pointer hover:bg-red-600">
//                 Update Profile
//               </button>
//             </Link>
//             <Link to="/ChangePassword" className="w-full">
//               <button className="bg-red-500 w-full text-white py-2 px-4 rounded cursor-pointer hover:bg-red-600">
//                 Change Password
//               </button>
//             </Link>
//             <button
//               onClick={handleLogout}
//               className="bg-red-500 w-full text-white py-2 px-4 rounded cursor-pointer hover:bg-red-600"
//             >
//               Logout
//             </button>

//             {userProfile.role === 'user' && (
//               <button
//                 onClick={handlehistory}
//                 className="bg-red-500 w-full text-white py-2 px-4 rounded cursor-pointer hover:bg-red-600"
//               >
//                 Order History
//               </button>
//             )}
//             {userProfile.role === 'provider' && (
//               <>
//                 <button
//                   onClick={() => navigate("/customer-orders")}
//                   className="bg-green-500 w-full text-white py-2 px-4 rounded cursor-pointer hover:bg-blue-400"
//                 >
//                   Customers Order History
//                 </button>
//                 <button
//                   onClick={() => navigate(`/gallery/upload/${userProfile._id}`)}
//                   className="bg-green-500 w-full text-white py-2 px-4 rounded cursor-pointer hover:bg-blue-400"
//                 >
//                   {/* //by uploading images here */}
//                   Manage Profile Gallery
//                 </button>
//               </>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // export default UserProfile;
// export default Profile;
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

// Global constant (assuming this is how it's defined in your environment)
const API_BASE = process.env.REACT_APP_API_BASE;

// ------------------- FULL SCREEN LOADER COMPONENT -------------------

const FullScreenLoader = () => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-green-700 bg-opacity-90">
      <div className="flex flex-col items-center">
        {/* Spinner */}
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-white mb-4"></div>
        <p className="text-white text-xl font-semibold">Loading Profile...</p>
      </div>
    </div>
);

const Profile = () => {
  const navigate = useNavigate();
  const [userProfile, setUserProfile] = useState({
    firstName: "Loading...",
    lastName: "Loading...",
    phoneNumber: "Loading...",
    avtar: "",
    role: "", // Initialize role
    _id: "" // Initialize _id for provider links
  });
  const [loading, setLoading] = useState(true); // 🚨 NEW LOADING STATE

  // Retrieve auth data securely
  let authObject = null;
  try {
    const authData = localStorage.getItem("auth");
    if (authData) {
      authObject = JSON.parse(authData);
    }
  } catch (error) {
    console.error("Error parsing auth data from localStorage:", error);
  }

  const token = authObject?.accessToken;

  useEffect(() => {
    // Redirect if no token is found
    if (!token) {
        setLoading(false);
        // Optionally redirect to login if not authenticated
        // navigate("/login"); 
        return; 
    }

    const fetchUserProfile = async () => {
      // 🚨 START LOADING
      setLoading(true);
      try {
        const res = await axios.get(
          `${API_BASE}/user/getCurrentUser`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        // Ensure to update all relevant fields, including role and _id
        setUserProfile(res.data.data);
      } catch (error) {
        console.error("Error fetching user profile:", error);
      } finally {
        // 🚨 STOP LOADING
        setLoading(false);
      }
    };
    fetchUserProfile();
  }, [token]);


  const handlehistory = () => {
    navigate("/OrderHistory");
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };
  
  // Render loading screen if data is not yet fetched
  if (loading) {
    return <FullScreenLoader />;
  }

  // Fallback for user not logged in or token missing (show message instead of crash)
  if (!token) {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
            <div className="p-8 bg-white rounded-lg shadow-xl text-center">
                <h2 className="text-xl font-semibold text-red-600 mb-4">Access Denied</h2>
                <p className="text-gray-600 mb-6">Please log in to view your profile.</p>
                <Link to="/login" className="py-2 px-4 bg-green-700 text-white rounded-md hover:bg-green-800 transition">
                    Go to Login
                </Link>
            </div>
        </div>
    );
  }

  return (
    <div
      className="flex items-center justify-center min-h-screen bg-cover bg-center px-4"
      style={{
        backgroundImage:
          // MF Blind style background
          "url('https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1950&q=80')",
      }}
    >
      <div className="max-w-sm w-full bg-white bg-opacity-95 rounded-lg overflow-hidden shadow-2xl p-6 border border-gray-300">
        
        {/* MF Blind-style Header */}
        <div className="mb-6 border-b pb-4 text-center">
            <h1 className="text-xl font-bold text-green-700">MF Blind</h1>
            <h2 className="text-2xl mt-2 text-gray-800">
              {userProfile.role === "provider" ? "Service Provider Profile" : "Customer Profile"}
            </h2>
        </div>

        {/* Profile Avatar and Info */}
        <div className="px-2 pb-6">
          <div className="text-center my-4">
            {/* Profile Picture (using avtar field) */}
            <img 
                src={userProfile.avtar || "https://placehold.co/100x100/047857/ffffff?text=P"} 
                alt="Profile Avatar"
                className="h-24 w-24 rounded-full object-cover mx-auto border-4 border-green-500 shadow-lg"
                onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/100x100/047857/ffffff?text=P" }}
            />
          </div>

          <div className="text-left text-gray-700 space-y-3 mt-6">
            <ProfileDetail label="First Name" value={userProfile.firstName} />
            <ProfileDetail label="Last Name" value={userProfile.lastName} />
            <ProfileDetail label="Phone Number" value={userProfile.phoneNumber} />
            {userProfile.role === "provider" && (
                <ProfileDetail label="Category" value={userProfile.category || 'N/A'} />
            )}
            <ProfileDetail label="Email" value={userProfile.email} /> 
          </div>
        </div>

        {/* Action Buttons (MF Blind Green/Blue Style) */}
        <div className="flex flex-col gap-3 px-2 border-t pt-6">
          
          {/* Main Actions (Green) */}
          <LinkButton to="/update-profile" color="green">Update Profile</LinkButton>
          <LinkButton to="/ChangePassword" color="green">Change Password</LinkButton>
          
          {/* Conditional Actions */}
          {userProfile.role === 'user' && (
            <ActionButton onClick={handlehistory} color="green">
              Order History
            </ActionButton>
          )}

          {userProfile.role === 'provider' && (
            <>
              <ActionButton onClick={() => navigate("/customer-orders")} color="blue">
                Customer Order History
              </ActionButton>
              <ActionButton onClick={() => navigate(`/gallery/upload/${userProfile._id}`)} color="blue">
                Manage Profile Gallery
              </ActionButton>
            </>
          )}
          
          {/* Logout Action (Green) */}
          <ActionButton onClick={handleLogout} color="red">
            Logout
          </ActionButton>
        </div>
      </div>
    </div>
  );
};

export default Profile;

// ------------------- Reusable Utility Components -------------------

const ProfileDetail = ({ label, value }) => (
    <div className="flex justify-between border-b border-gray-100 pb-1">
        <span className="font-medium text-gray-500">{label}:</span>
        <span className="font-semibold text-gray-800">{value}</span>
    </div>
);

const LinkButton = ({ to, children, color }) => {
    const baseStyle = "w-full py-2 px-4 rounded font-semibold transition duration-150 cursor-pointer text-white text-center";
    let colorStyle = "";

    switch (color) {
        case 'green':
            colorStyle = "bg-green-700 hover:bg-green-800";
            break;
        case 'blue':
            colorStyle = "bg-blue-600 hover:bg-blue-700";
            break;
        case 'red':
            colorStyle = "bg-red-500 hover:bg-red-600";
            break;
        default:
            colorStyle = "bg-gray-500 hover:bg-gray-600";
    }

    return (
        <Link to={to} className={`${baseStyle} ${colorStyle}`}>
            {children}
        </Link>
    );
};

const ActionButton = ({ onClick, children, color }) => {
    const baseStyle = "w-full py-2 px-4 rounded font-semibold transition duration-150 cursor-pointer text-white";
    let colorStyle = "";

    switch (color) {
        case 'green':
            colorStyle = "bg-green-700 hover:bg-green-800";
            break;
        case 'blue':
            colorStyle = "bg-blue-600 hover:bg-blue-700";
            break;
        case 'red':
            colorStyle = "bg-red-500 hover:bg-red-600";
            break;
        default:
            colorStyle = "bg-gray-500 hover:bg-gray-600";
    }

    return (
        <button onClick={onClick} className={`${baseStyle} ${colorStyle}`}>
            {children}
        </button>
    );
};